export * from './generationController.service';
import { GenerationControllerService } from './generationController.service';
export * from './generationController.serviceInterface';
export * from './guestNoteController.service';
import { GuestNoteControllerService } from './guestNoteController.service';
export * from './guestNoteController.serviceInterface';
export * from './healthController.service';
import { HealthControllerService } from './healthController.service';
export * from './healthController.serviceInterface';
export * from './imageController.service';
import { ImageControllerService } from './imageController.service';
export * from './imageController.serviceInterface';
export * from './languageController.service';
import { LanguageControllerService } from './languageController.service';
export * from './languageController.serviceInterface';
export * from './loginController.service';
import { LoginControllerService } from './loginController.service';
export * from './loginController.serviceInterface';
export * from './mySettingsController.service';
import { MySettingsControllerService } from './mySettingsController.service';
export * from './mySettingsController.serviceInterface';
export * from './rephraseController.service';
import { RephraseControllerService } from './rephraseController.service';
export * from './rephraseController.serviceInterface';
export * from './roomController.service';
import { RoomControllerService } from './roomController.service';
export * from './roomController.serviceInterface';
export * from './roomPriceController.service';
import { RoomPriceControllerService } from './roomPriceController.service';
export * from './roomPriceController.serviceInterface';
export * from './signatureController.service';
import { SignatureControllerService } from './signatureController.service';
export * from './signatureController.serviceInterface';
export * from './surchargePerDayController.service';
import { SurchargePerDayControllerService } from './surchargePerDayController.service';
export * from './surchargePerDayController.serviceInterface';
export * from './surchargePerStayController.service';
import { SurchargePerStayControllerService } from './surchargePerStayController.service';
export * from './surchargePerStayController.serviceInterface';
export * from './systemController.service';
import { SystemControllerService } from './systemController.service';
export * from './systemController.serviceInterface';
export * from './templateCategoryController.service';
import { TemplateCategoryControllerService } from './templateCategoryController.service';
export * from './templateCategoryController.serviceInterface';
export * from './templateController.service';
import { TemplateControllerService } from './templateController.service';
export * from './templateController.serviceInterface';
export * from './textController.service';
import { TextControllerService } from './textController.service';
export * from './textController.serviceInterface';
export * from './translationController.service';
import { TranslationControllerService } from './translationController.service';
export * from './translationController.serviceInterface';
export * from './userController.service';
import { UserControllerService } from './userController.service';
export * from './userController.serviceInterface';
export const APIS = [
  GenerationControllerService,
  GuestNoteControllerService,
  HealthControllerService,
  ImageControllerService,
  LanguageControllerService,
  LoginControllerService,
  MySettingsControllerService,
  RephraseControllerService,
  RoomControllerService,
  RoomPriceControllerService,
  SignatureControllerService,
  SurchargePerDayControllerService,
  SurchargePerStayControllerService,
  SystemControllerService,
  TemplateCategoryControllerService,
  TemplateControllerService,
  TextControllerService,
  TranslationControllerService,
  UserControllerService,
];
